var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#97D318"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0091 15C17.0077 15 17.0061 15 17.0047 15C16.5095 15 16.0437 15.193 15.692 15.5438C15.3365 15.8985 15.1406 16.3708 15.1406 16.8736V44.9674C15.1406 45.9976 15.982 46.8378 17.0165 46.8404C21.3774 46.8508 28.6838 47.7598 33.7242 53.0344V23.6334C33.7242 23.2842 33.635 22.9561 33.4666 22.6847C29.3297 16.0225 21.3799 15.0102 17.0091 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2162 44.9676V16.8736C55.2162 16.3708 55.0203 15.8985 54.6648 15.5438C54.3131 15.193 53.847 15 53.3523 15C53.3507 15 53.3491 15 53.3477 15C48.9771 15.0104 41.0273 16.0226 36.8902 22.6848C36.7218 22.9563 36.6328 23.2844 36.6328 23.6336V53.0344C41.6732 47.7598 48.9795 46.8508 53.3405 46.8404C54.3748 46.8378 55.2162 45.9976 55.2162 44.9676Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4841 21.479H58.1257V44.9675C58.1257 47.5979 55.9826 49.7428 53.3482 49.7493C49.6491 49.7581 43.55 50.4814 39.2305 54.5697C46.7011 52.7405 54.5765 53.9296 59.0648 54.9524C59.6252 55.08 60.2043 54.9481 60.6533 54.5903C61.1007 54.2333 61.3574 53.6997 61.3574 53.1269V23.3522C61.3575 22.3194 60.517 21.479 59.4841 21.479Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2317 44.9675V21.479H10.8732C9.84053 21.479 9 22.3194 9 23.3522V53.1264C9 53.6993 9.25667 54.2328 9.70409 54.5898C10.1527 54.9474 10.7313 55.0798 11.2926 54.9518C15.7808 53.9289 23.6564 52.74 31.1267 54.5691C26.8074 50.4811 20.7082 49.7579 17.0092 49.7491C14.375 49.7428 12.2317 47.5979 12.2317 44.9675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStories);
export default __webpack_public_path__ + "static/media/icon_stories.f41dc64e174f5ce50606209a1f0770c2.svg";
export { ForwardRef as ReactComponent };